<template>
  <div v-if="seminar_type">
    <Reporting_TH v-if="seminar_type === 'trading_heroes'" />
    <Reporting_GH_FH
      v-if="['finance_heroes', 'giro_heroes', 'young_heroes', 'security_heroes'].includes(seminar_type)"
    />
    <Reporting_FNDH v-if="seminar_type === 'founding_heroes'" />
    <div
      v-else
      class="message-container"
    >
      {{ message }}
    </div>
  </div>
  <div v-else>
    Seminar noch nicht gestartet...
  </div>
</template>

<script>
  import axios from "axios";
  import api from "../js/config/api";
  import Reporting_TH from "./Reporting/Trading_Heroes/Reporting_TH.vue";
  import Reporting_GH_FH from "./Reporting/Giro_Finance_Heroes/Reporting_GH_FH.vue";
  import Reporting_FNDH from "./Reporting/Founding_Heroes/Reporting_FNDH.vue";

  export default {
    name: "Main_Reporting",
    components: {Reporting_TH, Reporting_GH_FH, Reporting_FNDH},
    data: function () {
      return {
        seminar_type: '',
        message: '',
        errors: [],
      }
    },
    methods: {
      getType () {
        axios.get(`${api.getUrl()}/api/frontend/seminar-type/`)
          .then((response) => {
            if (response.data) {
              this.seminar_type = response.data;
            } else {
              this.message = response.data["message"];
            }
          })
          .catch(err => {
            this.errors.push(err);
          })
      }
    },
    mounted() {
      this.getType();
    }
  }
</script>
<style>
  .message-container {
    display: flex;
    justify-content: center;
    font-weight: bold;
    margin-top: 15px;
  }
</style>
